import React from "react";
import "./LetsGetPersonal.css";

import svg1 from "../../assets/aboutus/IMG_0571.jpg";
import svg2 from "../../assets/aboutus/IMG_0575.png";
import svg3 from "../../assets/aboutus/IMG_1108.png";
import svg4 from "../../assets/aboutus/IMG_1603.png";
import svg5 from "../../assets/aboutus/IMG_1694.png";
const LetsGetPersonal = () => {
  // const icons = [svg1, svg2, svg3, svg4, svg5, svg6, svg7, svg8];
  const icons = [svg1, svg2, svg3, svg4, svg5];

  return (
    <section className="lgp-wrapper">
      {/* Heading */}
      
        <h2 className="lgp-heading">"hey, this is us"</h2>

      {/* Description Text */}
      <div className="lgp-text">
        {/* <p>
          We're A Curious Mix Of Tea Lovers And A Little Bit Of Coffee Lovers,
          Midnight Coders, And Tech Nerds Who Somehow Make It All Work. Together.
          We Connect Through Playlists, Small Victories Over Pizza, And Think A Strong Team Is Built From Both Talent And Trust.
          Because There Are People Behind The Pixels. And We Think That's Something Worth Sharing.
        </p> */}
          <p>
            We're a curious mix of tea lovers and a little bit of coffee lovers,
            midnight coders, and tech nerds who somehow make it all work
            together. We connect through playlists, small victories over pizza,
            and believe a strong team is built from both talent and trust.{" "}
            <span className="special-font">
              Because there are people behind the pixels, and we think that's
              something worth sharing.
            </span>
          </p>
      </div>

      {/* Icon Scrolling Strip */}
      <div className="lgp-scroll-wrapper">
        <div className="lgp-icon-track">
          {icons
            .concat(icons)
            .concat(icons)
            .map((iconSrc, index) => (
              <div className="lgp-icon-item" key={index}>
                <img src={iconSrc} alt="" className="lgp-icon" loading="lazy" />
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default LetsGetPersonal;
